module.exports = __webpack_public_path__ + "img/cn-stu-3-t.49b9655f.png";